module.exports = __webpack_public_path__ + "fa85f1d8af2ca785aaaceae27c7670a7ad93bbcee0a3e20f33d37090842c9c06.png";